"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.colorDefinitions = void 0;
// tslint:disable:object-literal-sort-keys
exports.colorDefinitions = {
    // ORANGE
    orange100: '#651E00',
    orange80: '#B0481D',
    orange60: '#EE662F',
    orange50primary: '#FF9E75',
    orange40: '#FFC4AB',
    orange20: '#FFEAE1',
    orange10: '#FFF8F4',
    // BLUE
    blue100primary: '#2A355B',
    blue80: '#3D4B78',
    blue60: '#868EAB',
    blue50: '#B7BCCD',
    blue30: '#D8DBE4',
    blue20: '#F2F3F6',
    // TURQUOISE
    turquoise100: '#237E7B',
    turquoise60: '#75D2CF',
    turquoise30primary: '#B4E8E7',
    turquoise10: '#DFF6F6',
    // PURPLE
    purple100: '#4C0070',
    purple60primary: '#7A46A3',
    purple30: '#D7C8E3',
    purple10: '#F9F7FB',
    // BLACK
    black100: '#000000',
    blackTransparent50: 'rgba(0, 0, 0, 0.5)',
    grey100: '#161B22',
    grey80: '#30363D',
    // SKY BLUE
    skyBlue60: '#3A5FD5',
    skyBlue20: '#D1F0FF',
    // GREEN
    green80: '#108E36',
    green60: '#55DD7D',
    green20: '#D1F9DD',
    // YELLOW
    yellow80: '#D17100',
    yellow60: '#F6CD16',
    yellow20: '#F9F0CC',
    // PINK
    pink80: '#CC4141',
    pink60: '#FF7978',
    pink20: '#FFDFDF',
    primaryWhite: '#FFFFFF',
    transparent: 'transparent',
};
//# sourceMappingURL=colorDefinitions.js.map